var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    transform: "matrix(-1 0 0 1 55 0)",
    stroke: "#151515"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2062 32.5003C20.4051 32.8448 20.7327 33.0962 21.117 33.1992C21.5013 33.3022 21.9107 33.2483 22.2552 33.0494L32.5436 27.1094L31.1015 32.4915C31.0142 32.8702 31.0773 33.2681 31.2776 33.6012C31.4778 33.9343 31.7995 34.1767 32.1749 34.2773C32.5504 34.3779 32.9502 34.3288 33.2901 34.1404C33.6301 33.9521 33.8837 33.6391 33.9975 33.2675L36.3766 24.3883C36.4793 24.0043 36.4253 23.5952 36.2265 23.251C36.0278 22.9067 35.7005 22.6555 35.3166 22.5523L26.4375 20.1732C26.0587 20.0859 25.6609 20.149 25.3278 20.3492C24.9947 20.5495 24.7523 20.8712 24.6517 21.2466C24.5511 21.622 24.6002 22.0218 24.7885 22.3618C24.9769 22.7018 25.2898 22.9554 25.6615 23.0691L31.0436 24.5113L20.7552 30.4513C20.4107 30.6502 20.1593 30.9778 20.0564 31.3621C19.9534 31.7464 20.0073 32.1558 20.2062 32.5003Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/Left arrow.d1b63c2836e233c93d62ebeaec528397.svg";
export { ForwardRef as ReactComponent };